"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SAVE_PLAYBACK_POSITION_QUERY = "mutation SavePlaybackPosition($assetId: ID!, $position: Duration!) {\n  savePlaybackPosition(assetId: $assetId, position: $position) {\n    complete\n    position\n    lastWatched\n  }\n}";
exports.default = SAVE_PLAYBACK_POSITION_QUERY;
//# sourceMappingURL=savePlaybackPosition.js.map